// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ReactTable .rt-tbody{flex:99999 1 auto;display:flex;flex-direction:column;overflow-y:auto;overflow-x:hidden}\n", ""]);
// Exports
module.exports = exports;
